import { render, staticRenderFns } from "./MitMapsPage.vue?vue&type=template&id=20d27c4b&scoped=true"
import script from "./MitMapsPage.vue?vue&type=script&lang=js"
export * from "./MitMapsPage.vue?vue&type=script&lang=js"
import style0 from "./MitMapsPage.vue?vue&type=style&index=0&id=20d27c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d27c4b",
  null
  
)

export default component.exports